import {
  addManualParvandehForActiveUser,
  addManualParvandehForNewUser,
  getAllParvandehRoleHistory,
  getOneParvandeh,
  moveArchiveToParvandeh,
  moveParvandehToArchive,
  refreshParvandehStatus,
  updateParvandeh,
  editParvandehRole,
} from "./parvandeh-services";
import {
  addTerm,
  addTermRegisterCode,
  addTermState,
  editGeneralInformationTerm,
  editRegisterTypeTerm,
  editTermExtraAttachment,
  editTermExtraProfile,
  editTermState,
  getAllTermRegisterCode,
  getAllTermState,
  getOneTermState,
  getTerm,
  getTermV2,
  removeRegisterCode,
  removeTerm,
  removeTermState,
} from "./term-services";
import {
  addWhatsNew,
  deleteWhatsNew,
  editWhatsNew,
  getOneWhatsNew,
} from "./whats-new-services";
import {
  changeUserIsEnable,
  changeUserMobile,
  changeUserPassword,
  changeUserInfo,
  editUser,
  getProfileUser,
  getUser,
} from "./user-services";

export {
  getOneParvandeh,
  refreshParvandehStatus,
  addManualParvandehForNewUser,
  addManualParvandehForActiveUser,
  getAllParvandehRoleHistory,
  moveParvandehToArchive,
  moveArchiveToParvandeh,
  updateParvandeh,
  getUser,
  editUser,
  getProfileUser,
  changeUserPassword,
  changeUserInfo,
  changeUserMobile,
  editParvandehRole,
  changeUserIsEnable,
  getOneWhatsNew,
  addWhatsNew,
  editWhatsNew,
  deleteWhatsNew,
  getTerm,
  getTermV2,
  removeTerm,
  addTerm,
  addTermRegisterCode,
  getAllTermRegisterCode,
  removeRegisterCode,
  getAllTermState,
  getOneTermState,
  addTermState,
  editTermState,
  removeTermState,
  editTermExtraProfile,
  editTermExtraAttachment,
  editGeneralInformationTerm,
  editRegisterTypeTerm,
};
